export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const SET_ACCOUNTS_PAGINATION = 'SET_ACCOUNTS_PAGINATION';
export const SET_ACCOUNTS_FILTERS = 'SET_ACCOUNTS_FILTERS';
export const RESET_ACCOUNTS = 'RESET_ACCOUNTS';
export const TOGGLE_ACCOUNT = 'TOGGLE_ACCOUNT';
export const ADD_ACCOUNT = 'ADD_ACCOUNT';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const GET_ACCOUNT_BY_ID = 'GET_ACCOUNT_BY_ID';
export const RESET_ACCOUNT_FORM = 'RESET_ACCOUNT_FORM';
export const GET_ACCOUNT_FORM_CONFIG = 'GET_ACCOUNT_FORM_CONFIG';
export const MODIFY_EDITING_ACCOUNT = 'MODIFY_EDITING_ACCOUNT';
export const ADD_CUSTOM_FIELD_EDITING_ACCOUNT = 'ADD_CUSTOM_FIELD_EDITING_ACCOUNT';
export const REMOVE_CUSTOM_FIELD_EDITING_ACCOUNT = 'REMOVE_CUSTOM_FIELD_EDITING_ACCOUNT';

export const UPDATE_SELF_ACCOUNT = 'UPDATE_SELF_ACCOUNT';

//Groups
export const MODIFY_CUSTOM_FIELD_EDITING_ACCOUNT = 'MODIFY_CUSTOM_FIELD_EDITING_ACCOUNT';



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/constants/accounts_constants.js